import { render, staticRenderFns } from "./question_detail.vue?vue&type=template&id=0b87acf1&"
import script from "./question_detail.vue?vue&type=script&lang=js&"
export * from "./question_detail.vue?vue&type=script&lang=js&"
import style0 from "./question_detail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports